import { useMemo } from "react";
import { useGetRoleLabels } from "./RoleLabels";
import { AHText, Box, useTheme } from "arkh";
import Color from "color";

export function RoleTag(props: {
  role: "ADMIN" | "MANAGER" | "CO_WORKER" | "COWORKER_GROUP" | "READ_ONLY";
}) {
  const getRoleLabel = useGetRoleLabels();

  const color = "primary";
  const theme = useTheme();
  const backgroundColor = useMemo(() => {
    return Color(theme[color]).lighten(0.9).toString();
  }, [color, theme]);

  return (
    <Box
      cornerRadius="large"
      style={{ flexDirection: "row", alignItems: "center", backgroundColor }}
      spaceVertical="xsmall"
      spaceHorizontal="small"
    >
      <AHText type="info-small" color={color}>
        {getRoleLabel(props.role)}
      </AHText>
    </Box>
  );
}
